<template>
  <div class="c-idea-item" @click="$emit('click')">
    <header class="c-idea-item__header">
      <!-- <span class="c-idea-item__user-name">{{idea.user.name}}</span> -->
      <meta-row :user="true" :attatchments="true" :date="true"></meta-row>
    </header>

    <div class="c-idea-item__content">
      <h3 class="c-idea-item__title">{{idea.title}}</h3>
      <p class="c-idea-item__description">{{idea.description}}</p>
    </div>
  </div>
</template>

<script>
import MetaRow from '@/components/MetaRow';

export default {
  name: 'idea-item',

  props: ['idea'],

  components: {
    MetaRow,
  },
};
</script>


<style lang="scss">
.c-idea-item {
  padding: 1em;
  border-top: 1px solid $colour-nhs-pale-grey;
  cursor: pointer;

  &:hover {
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.11);
    border-color: transparent;
  }

  &__user-name {
    color: $colour-nhs-bright-blue;
    font-size: 14px;
    font-weight: bold;
  }

  &__title {
    color: #202020;
    font-size: 16px;
    font-weight: normal;
  }

  &__description {
    font-size: 14px;
    color: $colour-nhs-mid-grey;
  }
}
</style>
